export const initialState = {
	chartsRemediations: {}
};

export default { initialState };
